import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { featureEngineeringPageMeta, featureEngineeringSchema } from 'components/common/schema'
import Template from 'components/services/feature-engineering'

const Dx: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.remove('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...featureEngineeringPageMeta} />
      <JsonLd data={featureEngineeringSchema} />
      <Template />
    </>
  )
}

export default Dx
